import { HtmlParser } from '@calendly/html-parser'
import { I18n } from '@calendly/i18n'
import { Link } from '@calendly/ui/components/link'
import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { ORGANIZATION_INVITATION_PERMISSIONS } from 'constants/organization_invitation_permissions'
import { statisticsSelector } from 'features/organization_statistics'
import { orgInvitationPermissionsSelector } from 'selectors/current_organization'
import { isAdminOrOwnerSelector, isOnlyGroupAdminSelector } from 'selectors/current_user'


export const MEMBERS_PICKER_TRANSLATION_KEYS = {
  USER_GROUPS: 'user_groups_add_members',
  MANAGED_EVENT_TYPES: 'managed_event_types',
  EVENT_TYPES: 'event_types'
}

const translationPicker = (type) => {
  switch (type) {
    case MEMBERS_PICKER_TRANSLATION_KEYS.USER_GROUPS:
      return {
        ADMIN: I18n.t('publisher.organization.user_groups.management.add_members.not_found_description_admin'),
        GROUP_ADMIN: I18n.t('publisher.event_types.member_picker.not_found_description_group_admin'),
        USER: I18n.t('publisher.organization.user_groups.management.add_members.not_found_description'),
      }
    case MEMBERS_PICKER_TRANSLATION_KEYS.MANAGED_EVENT_TYPES:
      return {
        ADMIN: I18n.t('publisher.organization.managed_event_types.assign.add_members.not_found_description'),
        GROUP_ADMIN: I18n.t('publisher.event_types.member_picker.not_found_description_group_admin'),
        USER: I18n.t('publisher.event_types.member_picker.not_found_description'),
      }
    case MEMBERS_PICKER_TRANSLATION_KEYS.EVENT_TYPES:
    default:
      return {
        ADMIN: I18n.t('publisher.event_types.member_picker.not_found_description_admin'),
        GROUP_ADMIN: I18n.t('publisher.event_types.member_picker.not_found_description_group_admin'),
        USER: I18n.t('publisher.event_types.member_picker.not_found_description'),
      }
  }
}

const AddMemberLink = ({ children }) => {
  const inviteUrl = '/app/admin/invitations/new'

  return (
    <Link href={inviteUrl} target="_blank" rel="opener">{children}</Link>
  )
}

export const MemberPickerNotFoundText = ({ scope, invitationLink = AddMemberLink }) => {
  const { available_seats: availableSeats } = useSelector(statisticsSelector)
  const isAdminOrOwner = useSelector(isAdminOrOwnerSelector)
  const isOnlyGroupAdmin = useSelector(isOnlyGroupAdminSelector)

  const orgInvitationPermissions = useSelector(orgInvitationPermissionsSelector)
  const canInviteAsGroupAdmin = isOnlyGroupAdmin
    && [ORGANIZATION_INVITATION_PERMISSIONS.GROUP_ADMIN, ORGANIZATION_INVITATION_PERMISSIONS.USER].includes(orgInvitationPermissions)
  const canInviteAsEndUser = !isAdminOrOwner && !isOnlyGroupAdmin
    && orgInvitationPermissions === ORGANIZATION_INVITATION_PERMISSIONS.USER
  const canInvite = canInviteAsGroupAdmin || canInviteAsEndUser

  const translationKey = useMemo(() => translationPicker(scope), [scope])

  if (isAdminOrOwner || (canInvite && availableSeats > 0)) {
    return (
      <span>
        {
          HtmlParser(
            translationKey.ADMIN,
            {
              AddMemberLink: invitationLink,
              NewInvitationLink: invitationLink
            }
          )
        }
      </span>
    )
  }

  if (canInvite) {
    return <span>{translationKey.GROUP_ADMIN}</span>
  }

  return <span>{translationKey.USER}</span>
}
